export const GROK = 'GROK';

export const sqlKeywords = [
  'select',
  'from',
  'where',
  'and',
  'or',
  'group',
  'by',
  'order',
  'limit',
  'offset',
  'having',
  'as',
  'case',
  'when',
  'then',
  'else',
  'end',
  'type',
  'left',
  'right',
  'join',
  'on',
  'outer',
  'desc',
  'asc',
  'union',
  'primary',
  'key',
  'if',
  'foreign',
  'not',
  'references',
  'default',
  'null',
  'inner',
  'cross',
  'natural',
  'database',
  'distinct',
];

export const sqlContants = ['true', 'false'];

export const sqlBuildInFunctions = [
  'avg',
  'count',
  'first',
  'last',
  'max',
  'min',
  'sum',
  'ucase',
  'lcase',
  'mid',
  'len',
  'round',
  'rank',
  'now',
  'format',
  'coalesce',
  'ifnull',
  'isnull',
  'nvl',
];

export const sqlDataTypes = [
  'int',
  'numeric',
  'decimal',
  'date',
  'varchar',
  'char',
  'bigint',
  'float',
  'double',
  'bit',
  'binary',
  'text',
  'set',
  'timestamp',
  'money',
  'real',
  'number',
  'integer',
];

export const LOG_DB_NAME = 'log';
export const SQL_LANG_TYPE = 'sql';
export const lmTableNames = ['log'];
export const anlyTableNames = ['analytics', 'error'];

export const SOURCE = 'SOURCE';
export const TEXT = 'TEXT';
export const SQL = 'SQL';
export const timeStamp = 'timestamp';
export const timeStampEpoch = 'timestamp_epoch';
export const timeStampFormat = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const ALL = 'ALL';
export const RAW = 'raw';
export const eventTS = 'event_ts';

export const LOG_QUERY_TABLE_LIMIT = 50;
export const LOG_SAVED_SEARCH_TABLE_LIMIT = 30;
export const LOG_GROK_PATTERN_LENGTH = 5000;

export const VIEW_LOGS_TAB_KEY = 'logs';
export const VIEW_GROK_TAB_KEY = 'grok';
export const VIEW_SAVED_SEARCHES_TAB_KEY = 'searches';

export const ADD_GROK_PATTERN = 'grokPattern';
export const ADD_SAVED_SEARCH = 'savedSearch';

export const NAME_FIELD_REGEX = '^[-_a-zA-Z0-9 ]+$';

export const LINE_GRAPH = 'ChartLineCustom';
export const BAR_GRAPH = 'ApexChartBar';
export const STATUS_LABEL = 'StatusLabel';
export const TABLE_WIDGET = 'TableWidget';

export const METRIC_QUERY_TYPE = 'METRIC';
export const TABLE_QUERY_TYPE = 'TABLE';

export const DEBOUNCE_INPUT_TIME = 500;

export const DELETE_MENU_KEY = 'DELETE';
export const RUN_MENU_KEY = 'RUN';
export const EDIT_MENU_KEY = 'EDIT';
export const ADD_WIDGET_MENU_KEY = 'ADD_WIDGET';
export const ALERT_MENU_KEY = 'ALERT';
export const COPY_MENU_KEY = 'COPY';

export const LM_CAPABILITY = 'L';
export const ANALYTICS_CAPABILITY = 'ANL';
export const ANALYTICS_DB_NAME = 'analytics';
export const ANALYTICS_SOURCE_QUERY_PREFIX = `select * from ${ANALYTICS_DB_NAME} where service=`;

export const TRACE_LOG_QUERY_PREFIX = 'select * from log where trace_id =';
export const TRACE_ID = 'trace_id';
export const LOG_TYPE_RAW = 'RAW';

export const LOG_PAGE_SIZE = 20;
export const DESC = 'DESC';
export const THROTTLE_INPUT_TIME = 300;
